import { gql, WatchQueryFetchPolicy } from "@apollo/client";
import { useLazyQuery, useQuery } from "@apollo/client/react";
import { useVisitor } from "@ct-react/visitor";

const CART_BADGE_GQL_DATA = gql`
  query CartBadge($sessionId: String, $userId: String) {
    cart(sessionId: $sessionId, userId: $userId) { cartId itemsCount }
  }
`;

export const useCartCount = (fetchPolicy?: WatchQueryFetchPolicy): number => {
  const { isLoggedIn, ...variables } = useVisitor();
  const { data } = useQuery<any>(CART_BADGE_GQL_DATA, { variables, ...(!!fetchPolicy) && { fetchPolicy } });
  return data?.cart?.itemsCount || 0;
}

export const useLazyCartCount = (fetchPolicy?: WatchQueryFetchPolicy): () => Promise<number> => {

  const { isLoggedIn, ...variables } = useVisitor();
  const [ getCount ] = useLazyQuery<any>(CART_BADGE_GQL_DATA, !!fetchPolicy ? { fetchPolicy } : undefined);

  return () => new Promise<number>((resolve, reject) => getCount({ variables })
      .then(({ data }) => !!data?.cart?.itemsCount
        ? resolve(data?.cart?.itemsCount)
        : reject())
      .catch(() => reject()));

}
